import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeftLong, faPlus } from "@fortawesome/pro-regular-svg-icons";
import HeaderBar from "../../components/HeaderBar";
import Sidebar from "../../components/Sidebar";
import { useAuth } from "../../providers/AuthContext";
import { createBillingGroup } from "../../api/BillingGroups";
import toast from "react-hot-toast";
import Breadcrumbs from "../../components/Breadcrumbs";
import EditForm from "../../components/EditForm";
import { useSidebar } from "../../providers/SidebarContext";

const CreateBillingPage = () => {
  const { getAccessToken } = useAuth();
  const { agreementPublicId, user } = useParams();
  const navigate = useNavigate();
  const { syncData } = useSidebar();
  const [hasChanges, setHasChanges] = useState(false);
  const [billingGroup, setBillingGroup] = useState({
    agreementPublicId: agreementPublicId || "",  // Försök hämta från URL, annars tomt
    entraTenantId: "", 
    ingramCustomerId: 0, 
    displayName: "",
    domain: "",
  });

  const handleBackClick = () => {
    navigate(-1);
  };

const handleCreateBillingGroup = async () => {
  try {
    const accessToken = await getAccessToken();
    if (!accessToken) {
      toast.error("Authorization failed. Please log in again.");
      return;
    }

    // Kontrollera att alla fält är ifyllda
    if (!billingGroup.agreementPublicId) {
      toast.error("The billing group must be associated with an agreement.");
      return;
    }      
          const createPayload = {
            agreementPublicId: billingGroup.agreementPublicId,
            name: billingGroup.name,
            status: billingGroup.status,
            comment: billingGroup.comment,
            isDefault: billingGroup.isDefault,
          };
      
          console.log("Sending billng group Data:", createPayload);
          
          await createBillingGroup(
            createPayload,
            accessToken
          );

    
    toast.success("Billing group created successfully", {
      iconTheme: {
        primary: "#4CAF50",
        secondary: "#DFF2BF",
      },
    });

    syncData();
  } catch (error) {
    console.error("Failed to create billing group:", error);
    toast.error("Failed to create billing group");
  }
  navigate(-1);
};

console.log("CREATE BILLINGGROUP PAGE");

  return (
    <>
      <HeaderBar />
      <div className="flex flex-row w-full">
        <Sidebar />
        <main className="page">
          <div className="page-content">
            <Breadcrumbs />
            <div className="flex flex-row items-center pb-4">
              <button onClick={handleBackClick} className="text-black flex">
                <FontAwesomeIcon icon={faArrowLeftLong} className="w-4 pr-4" />
              </button>
              <h2 className="border-l border-mute-200 pl-4">Create billing group</h2>
              <div className="flex gap-4 ml-auto">
                <button className="btn btn-outline-primary" onClick={handleBackClick}>
                  Cancel
                </button>
                <button className="btn btn-primary" disabled={!hasChanges} onClick={handleCreateBillingGroup}>
                  Save
                </button>
              </div>
            </div>
            <div className="flex flex-col px-4 py-8 shadow-lg border rounded-md w-full gap-4">
              <EditForm
                data={billingGroup}
                setData={setBillingGroup}
                setHasChanges={setHasChanges}
                disabled={false}
                fields={[
                  { key: "billingGroupPublicId", label: "Billing group ID", type: "text", disabled: true},
                  { key: "name", label: "Name", type: "text" },
                  { key: "status", label: "Status", type: "dropdown", options: [
                    { value: "Active", label: "Active" },
                    { value: "Inactive", label: "Inactive" },
                  ], },
                  { key: "comment", label: "Comment", type: "text" },
                  { key: "createdBy", label: "Created by", type: "text", disabled: true },
                  { key: "createdDateTimeUTC", label: "Created date", type: "text", disabled: true },
                  { key: "updatedBy", label: "Updated by", type: "text", disabled: true },
                  { key: "updatedDateTimeUTC", label: "Updated date", type: "text", disabled: true },
                ]}
              />
            </div>
          </div>
        </main>
      </div>
    </>
  );
};

export default CreateBillingPage;
